import { Box, Typography, useTheme } from "@mui/material";
import { Block, Button } from "../../../shared";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { v } from "../../../../utils/runtime";

export function ForeignCardBlock() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation("home");

  return (
    <Block sx={{ position: "relative", overflow: "hidden" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "16px",
          position: "relative",
          maxWidth: "100%",
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            flex: 1,
            minWidth: 0,
          }}
        >
          <Box
            component="img"
            src={v("/ffcard.png")}
            sx={{
              objectFit: "contain",
              height: "40px",
            }}
          />
          <Typography sx={{ fontSize: 15, fontWeight: 500, pt: 0.5 }}>
            {t("foreign_card.title")}
          </Typography>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 400,
              opacity: 0.5,
              lineHeight: "1.2",
              pt: 0.5,
            }}
          >
            {t("foreign_card.subtitle")}
          </Typography>
        </Box>

        <Button
          disableGlassEffect
          onClick={() => navigate("/foreign-card")}
          sx={{
            bgcolor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.09)" : "#e0e0e0",
            color: theme.palette.mode === "dark" ? "#fff" : "#000",
            borderRadius: "40px",
            padding: "0px 14px",
            fontSize: "11px",
            fontWeight: "500",
            width: "auto",
            flexShrink: 0,
            minHeight: "35px",
            "&:hover": {
              bgcolor:
                theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.09)" : "#e0e0e0",
            },
          }}
        >
          {t("foreign_card.cta")}
        </Button>
      </Box>
    </Block>
  );
}
